import { render } from "./HeaderNotificationsBlock.vue?vue&type=template&id=bf9babde"
import script from "./HeaderNotificationsBlock.vue?vue&type=script&lang=js"
export * from "./HeaderNotificationsBlock.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__